import styles from "./AccountCreatedPage.module.css";
import i18n from "../Services/i18n";

const AccountCreatedPage = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageContainer}>
        <div className={styles.loginWrapper}>
          <div className={styles.equestrologLogo}>Bienvenue</div>
          <div className={styles.loginForm}>
            <p>{i18n.t("RegisterForm.AccountCreated.CreationConfirmed")}</p>

            <div className={styles.loginFormFooter}>
              <button
                className={styles.loginButton}
                onClick={() => {
                  window.location.href = "/login";
                }}>
                {i18n.t("RegisterForm.AccountCreated.GoToLogin")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountCreatedPage;
